import { render, staticRenderFns } from "./DutyManagementIndex.vue?vue&type=template&id=25098e3e"
import script from "./DutyManagementIndex.vue?vue&type=script&lang=js"
export * from "./DutyManagementIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports